import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSolicitationCostCenters } from '@services/workflow/solicitationCostCenter/solicitationCostCenter.service';

export const fetchSolicitationCostCenters = createAsyncThunk(
  'solicitationCostCenter/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const data = await getSolicitationCostCenters();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Falha ao buscar centros de custo');
    }
  }
);

const initialState = {
  list: [],
  loading: false,
  error: null,
};

const solicitationCostCenterSlice = createSlice({
  name: 'solicitationCostCenter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSolicitationCostCenters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSolicitationCostCenters.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchSolicitationCostCenters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default solicitationCostCenterSlice.reducer;